<template>
<div>
<!-- 顶部球衣 -->
  <div class="topQiuyi">
    <img src="../assets/vblogo.png" alt="" class="vblogo">

  </div>
  <!-- 图标部分 -->
  <div class="picIcon">
    
  </div>
  <!-- 防伪验证 -->
  <div class="fwyzBox">
        <h2 class="inputHead">防伪验证</h2>
        <p class="inputHead2">ANTI-COUNTERFEITING VERIFICATION</p>
        <input placeholder="请输入8位编码" class="inptstyle" v-model="barCode">
        <button class="btnstyle" v-on:click="pushpage()">立即查询</button>
    </div>
    <div class="bottomTag">
        <p class="mdlb">门店列表</p>
        <p class="storelist">STORE LIST</p>
    </div>
    <!-- 门店列表 -->
    <div class="mdTab">
        <div class="mdItem" v-for="item in mdLIst" :key="item">
            <div class="mdxqlogo">
                <img src="../assets/ltlogo.png" alt="" class="imglogo">
            </div>
                <p class="mdname">{{item.mdName}}</p>
                <div class="mdwz"> 
                    <img src="../assets/dd.png" alt="" class="ddicon">
                    <div class="mddzdiv">
                        <font class="mddz">{{item.mdDz}}</font>
                    </div>
                </div>
                <!-- 时间地址 -->
                <div class="sjdh">
                    <!-- <img src="../assets/time.png" alt="" class="sjicon"> -->
                    <p class="Left mdtime">{{item.mdTime}}</p>
                    <!-- <img src="../assets/dh.png" alt="" class="sjicon lxdh"> -->
                    <p class="mddh" v-on:click="callPhoneNumber(item.mdTel)">{{item.mdTel}}</p>
                </div>
                <div class="mdpic">
                    <img :src="require(`../assets/${item.mdImg}` )" alt="" class="mdpiture">
                </div>
            </div>
    </div>
    <router-view></router-view>
</div>
</template>

<script>
export default {
    name:"mainPage",
    data(){
        return{
            // 输入验证码
            iptyzm:"",
            flag:false,
            barCode: "",
            mdLIst:[
                {mdName:"VBEINGS微缤礼物（长沙国金中心店）",mdImg:"mdpicture01.jpg",mdDz:"湖南省长沙市芙蓉区长沙国金中心G层LG112-113",mdTime:"10:00-22:00",mdTel:"13548565437"},
                {mdName:"VBEINGS微缤礼物（长沙运达汇店）",mdImg:"mdpicture02.jpg",mdDz:"湖南省长沙市雨花区运达中央广场1层L136",mdTime:"10:00-22:00",mdTel:"13109960638"},
                {mdName:"VBEINGS微缤礼物（长沙北辰荟店）",mdImg:"mdpicture03.jpg",mdDz:"开福区北辰三角洲北辰荟G层微缤礼物G15-G16",mdTime:"10:00-22:00",mdTel:"18873720093"},
                {mdName:"VBEINGS微缤礼物（长沙海信广场店）",mdImg:"mdpicture04.jpg",mdDz:"湖南省长沙市天心区海信广场2层206",mdTime:"10:00-22:00",mdTel:"13739063302"},
                {mdName:"VBEINGS微缤礼物（杭州中心店）",mdImg:"mdpicture05.jpg",mdDz:"浙江省杭州市拱墅区杭州中心B1层B127",mdTime:"10:00-22:00",mdTel:"18164966064"},
                {mdName:"VBEINGS微缤礼物（武汉SKP店）",mdImg:"mdpicture06.jpg",mdDz:"湖北省武汉市武昌区沙湖大道18号SKP-GF层B1008",mdTime:"10:00-22:00",mdTel:"18627870303"},
                {mdName:"VBEINGS微缤礼物（青岛海信广场店）",mdImg:"mdpicture07.jpg",mdDz:"山东省青岛市市南区澳门路117号海信广场B1层",mdTime:"10:00-21:30",mdTel:"18561104060"},
                {mdName:"VBEINGS微缤礼物（昆明恒隆广场店）",mdImg:"mdpicture08.jpg",mdDz:"云南省昆明市盘龙区东风东路恒隆广场5层",mdTime:"10:00-22:00",mdTel:"18314428408"},
                {mdName:"VBEINGS微缤礼物（成都国金中心店）",mdImg:"mdpicture09.jpg",mdDz:"成都市锦江区红星路三段1号IFS国金中心L510",mdTime:"10:00-22:00",mdTel:"18164966064"},
                {mdName:"VBEINGS微缤礼物（武汉武商MALL店）",mdImg:"mdpicture10.jpg",mdDz:"江汉区解放大道690号武商Mall购物中心B1层AG1-4",mdTime:"10:00-22:00",mdTel:"18627870303"},
                {mdName:"VBEINGS微缤礼物（长沙万象城店）",mdImg:"mdpicture11.jpg",mdDz:"湖南省长沙市岳麓区万象城2层L259",mdTime:"10:00-22:00",mdTel:"13548565437"}
            ]
        }
    },
    created(){
        //console.log("执行到了") 
        let urlParams = new URLSearchParams(window.location.search);
        let barCode = urlParams.get('barcode');
        console.log(barCode); // 输出: vb000132
        if(barCode!= "" && barCode!= null)

        {
            this.barCode = barCode;
            this.pushpage()
        }
    },
    methods:{
        // 点击事件
        pushpage(){
            // console.log("1111")
            // this.$router.push('yzPage')
            this.$router.push({ path: '/yzPage', query: { barcode: this.barCode }})
            this.$store.state.yzmflag = true
            // console.log("main"+this.$store.state.yzmflag)
        },
        callPhoneNumber(phoneNumber) {
        // 格式化电话号码，确保符合拨打链接的要求，例如在号码前面加 + 或 00
        const formattedPhoneNumber = `tel:${phoneNumber.replace(/^0+/, '')}`;
        // 使用window.location.href导航到电话链接
        window.location.href = formattedPhoneNumber;
      }
    }
}
</script>

<style>
.vblogo{
    width: 245px;
    position: absolute;
    top:58px;
    left: 45px;
}
/* 顶部球衣 */
.topQiuyi{
    width: 100%;
    height: 600px;
    /* background-col
    or: rgb(232, 113, 113); */
    background-image: url(../assets/qiuyi.png);
    background-size: 100%;
}
.picIcon{
    width: 100%;
    height: 370px;
    /* background-col
    or: rgb(232, 113, 113); */
    background-image: url(../assets/picicon.png);
    background-size: 100%;
    margin-top: -60px;
}
/* 防伪验证 */
.fwyzBox{
    width: 100%;
    height: 340px;
    background-color:rgb(255, 255, 255);
    color: black;
    text-align: center;
    padding-top: 20px;
    /* background-color: rgb(156, 238, 102); */
}
.inputHead{
    font-size: 35px;
    font-weight: 600;
    margin-top: 20px;
}
.inputHead2{
    font-size: 22px;
    font-weight: 550;
    margin-top: -25px;
}
/* 验证码输入框 */
.inptstyle{
    width: 530px;
    height: 75px;
    border-radius: 5px;
    margin-top: 15px;
    font-size: 25px;
    box-sizing: border-box;
    color: rgb(68, 67, 67);
    text-align: center;
    outline: 0px;
}

.inptstyle::placeholder {
  opacity: 0.5;
  color: rgb(112, 111, 111);
  margin-left: 10px;
  padding-left: 0 10px;
}
/* 点击查询按钮 */
.btnstyle{
    display: block;
    width: 533px;
    height: 75px;
    margin: 20px auto;
    border-radius: 5px;
    background-color: rgb(236, 61, 46);
    color: rgb(242, 233, 233);
    font-size: 28px;
    border: none;
}
.bottomTag{
    padding-top: 5px;
    padding-bottom: 20px;
    color: black;
    text-align: center;
    background-color: rgb(246,246,246);
}
.mdlb{
    font-size: 30px;
    font-weight: 600;
    margin-bottom: 10px;
}
.storelist{
    font-size: 18px;
    font-weight: 500;
    margin-top: 0px;
}

.mdTab{
    background-color: rgb(246,246,246);
    padding-bottom: 10px;
}
/* 门店列表详情 */
.mdItem{
    width: 87%;
    height: 100px;
    background-color: rgb(255, 255, 255);
    border-radius: 20px;
    padding: 15px 10px;
    text-align: left;
    margin-left: 5%;
    margin-bottom: 20px;
    position: relative;
}
/* 门店logo */
.mdxqlogo{
    float: left;
    width: 25px;
    height: 25px;
    margin-left: 15px;
    margin-top: 5px;
}
/* logo图片 */
.imglogo{
    width: 25px;
    height: 25px;
    position: absolute;
}
/* 门店名称 */
.mdname{
    font-size: 20px;
    font-weight: 650;
    margin-top: 4px;
    margin-left: 45px;
    color: black;
    position: absolute;
}
/* 位置 */
.ddicon{
    float: left;
    width: 13px;
    height: 14px;
    position: absolute;
    top: 59px;
    left: 29px;
}
/* 门店地址div */
.mddzdiv{
    width: 5.53333rem;
    position: absolute;
    background-color: rgb(155, 243, 244);
}
/* 地址 */
.mddz{
    font-size: 16px;
    font-weight: 500;
    position: absolute;
    top: 40px;
    left: 40px;
}

.mdwz{
    color: rgb(114 112 112);
}
.sjdh{
    float: left;
    width: 350px;
    color: rgb(114 112 112);
    position: absolute;
    /* background-color: rgb(85, 21, 21); */
}
/* 时间图标 */
.sjicon{
    float: left;
    width: 15px;
    position: absolute;
    bottom: -86px;
    left: 20px;
}
/* 时间 */
.mdtime{
    font-size: 16px;
    position: absolute;
    bottom: -104px;
    left: 35px;
}
/* 联系电话 */
.lxdh{
    font-size: 16px;
    position: absolute;
    bottom: -85px;
    left: 140px;
}
/* 门店电话 */
.mddh{
    font-size: 16px;
    position: absolute;
    bottom: -104px;
    left: 155px;
}
/* 门店详情图片 */
.mdpic{
    width: 220px;
    height: 135px;
    border-radius: 15px;
    /* background-color: rgb(141, 42, 42); */
    /* background-image: url(../assets/mdpic.png); */
    background-position-y: -45px;
    background-position-x: -15px;
    background-size: 330px;
    position: absolute;
    right: -7px;
    top:7px;
}
.mdpiture{
    width: 200px;
    height: 115px;
    border-radius: 10px;
}
</style>